/**
 * @module task.transformer
 */
import { datetime } from '~/tools/datetime';
import { defaultLang } from '~/config/settings/app.settings';
import { text } from '~/tools/text';

interface Task {
  id: string;
  libraryActionId: string;
  ownerUserId: string;
  surveyTypeId: string;
  title?: string;
  description?: string;
  translations: Record<string, { title?: string; description?: string }>;
  dueAt: string;
  users: { id: number; name: string }[];
  surveys: string[];
  categories: string[];
  isComplete: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface TransformedTask {
  id: string;
  taskTemplateId: string;
  userId: string;
  surveyTypeId: string;
  title: string;
  description: string;
  translations: Record<string, { title?: string; description?: string }>;
  dueAt: string;
  users: { id: number; name: string }[];
  surveys: string[];
  categories: string[];
  isComplete: boolean;
  isOverdue: boolean;
  isAlmostdue: boolean;
  createdAt: string;
  updatedAt: string;
}

const taskFrom = (task: Task): TransformedTask => {
  const defaultTitle =
    task.title || task.translations[defaultLang]?.title || text.findFirstTranslationFor(task.translations, 'title');

  const defaultDescription =
    task.description ||
    task.translations[defaultLang]?.description ||
    text.findFirstTranslationFor(task.translations, 'description');

  return {
    id: task.id,
    taskTemplateId: task.libraryActionId,
    userId: task.ownerUserId,
    surveyTypeId: task.surveyTypeId,
    title: defaultTitle,
    description: defaultDescription,
    translations: task.translations,
    dueAt: task.dueAt,
    users: task.users,
    surveys: task.surveys,
    categories: task.categories,
    isComplete: task.isComplete,
    isOverdue: datetime.isAfter(new Date(), new Date(task.dueAt)) && !task.isComplete,
    isAlmostdue: datetime.isBefore(datetime.subDays(new Date(task.dueAt), 2), new Date()) && !task.isComplete,
    createdAt: task.createdAt,
    updatedAt: task.updatedAt,
  };
};

const tasksFrom = (taskList: Task[] = []) => {
  return taskList.map((task) => taskFrom(task));
};

export { taskFrom, tasksFrom };
